export default {
    Role: {
        User: 1,
        Admin: 2,
    },

    DeviceStatus: {
        Active: 1,
        InActive: 2
    },

    Event: {
        None: 0,
        Add: 1,
        Edit: 2,
        Delele: 3,
        View: 4,
        More: 5,
    },

    Mode: {
        View: 0,
        Add: 1,
        Edit: 2,
    },
    FormatType: {
        Number: 1,
        Date: 2,
        DateTime: 3,
        Time: 4
    },

    ScreenType: {
        Mobile: 1,
        Tablet: 2,
        Computer: 3
    }
}


